const doc = [({"title":({"de":""}), "heroImage":"/images/puppy-weekend-2025/banner.png", "sections":[]})];
module.exports = doc.length <= 1 ? doc[0] : doc;